import { useMutation, useQuery } from 'react-query';
import { accountDao } from 'shared/dao/accountDao';
import {
  IAccountDeleteConfirmationPayload,
  IAccountDeleteRequestPayload,
  IAccountResponsePayload,
  IAccountUpdatePayload,
} from 'shared/interfaces/IAccount';

const {
  getAccount: getAccountDao,
  updateAccount: updateAccountDao,
  deleteAccount: deleteAccountDao,
  deleteAccountConfirmation: deleteAccountConfirmationDao,
  initiateDelete: initiateDeleteDao,
} = accountDao();
export const accountService = () => {
  const getAccount = () => {
    return useQuery<IAccountResponsePayload, Error>(['accounts'], () => getAccountDao());
  };

  const updateAccount = () => {
    return useMutation((payload: IAccountUpdatePayload) => updateAccountDao(payload));
  };

  const deleteAccount = () => {
    return useMutation((payload: IAccountDeleteRequestPayload) => deleteAccountDao(payload));
  };

  const deleteAccountConfirmation = () => {
    return useMutation((payload: IAccountDeleteConfirmationPayload) => deleteAccountConfirmationDao(payload));
  };

  const initiateDelete = () => {
    return useMutation((payload: { email: string }) => initiateDeleteDao(payload));
  };

  return {
    initiateDelete,
    deleteAccountConfirmation,
    getAccount,
    updateAccount,
    deleteAccount,
  };
};
